export default {
  EVENT_SETTINGS_UPDATED: '¡La configuración del evento se ha actualizado correctamente!',
  DAILY_REPORTS_ENABLED: 'Informes diarios habilitados',
  EVENT_SETTINGS: 'Configuración de eventos',
  ARCHIVAL_DAYS: 'Días de archivo',
  EVENT_ARCHIVAL_DATE: 'El evento se archivará el '
}
